import { FormDropdownOption } from "../../components/forms";
import { NamedProperty } from "../types/NamedProperty";

export const mapNamedPropertyToAutocompleteDropdownOption = (
    value: NamedProperty | { id: number; name: string }
): FormDropdownOption => ({
    key: value.id,
    text: value.name
});
